(() => {

    /* ==========================================
       BUSCA A MÍDIA ATIVA DO PRODUTO
    ========================================== */

    const getMedia = () =>
        document.querySelector(
            'media-gallery slideshow-slide[aria-hidden="false"] .product-media'
        ) ||
        document.querySelector(
            'media-gallery slideshow-slide.is-active .product-media'
        ) ||
        document.querySelector(
            'media-gallery .slideshow-slide.is-active .product-media'
        ) ||
        document.querySelector(
            'media-gallery .media-gallery__grid .product-media'
        ) ||
        document.querySelector(
            'media-gallery .product-media'
        ) ||
        document.querySelector(
            'media-gallery .product__media'
        ) ||
        document.querySelector(
            'media-gallery .product-gallery'
        );


    /* ==========================================
       VERIFICA SOU DE ALGODÃO
    ========================================== */

    const getAlgodaoMarker = () =>
        document.querySelector(
            '[data-sou-de-algodao="true"]'
        );


    /* ==========================================
       CRIA O SELO SOU DE ALGODÃO
    ========================================== */

    const createAlgodaoBadge = () => {

        const marker = getAlgodaoMarker();

        if (!marker)
            return null;

        const imageSrc =
            marker.dataset.tagAlgodaoSrc;

        if (!imageSrc)
            return null;


        const badge =
            document.createElement('div');

        badge.className =
            'algodao-banner';


        const img =
            document.createElement('img');

        img.className =
            'algodao-banner__image';

        img.src = imageSrc;

        img.alt = 'Sou de Algodão';

        img.loading = 'lazy';

        img.width = 40;


        badge.appendChild(img);

        return badge;

    };


    /* ==========================================
       GARANTE O SELO NO PDP
    ========================================== */

    const updateAlgodaoBadge = () => {

        const marker =
            getAlgodaoMarker();

        const existingBadges =
            document.querySelectorAll(
                '.algodao-banner'
            );


        /*
         * Produto NÃO pertence
         * à coleção Sou de Algodão
         */

        if (!marker) {

            existingBadges.forEach(
                badge => badge.remove()
            );

            return;

        }


        /*
         * Produto pertence
         * à coleção Sou de Algodão
         */

        let containers =
            Array.from(
                document.querySelectorAll(
                    '.product-page-badges'
                )
            );


        /*
         * Se o produto não possuir nenhum
         * outro badge, cria o container.
         */

        if (!containers.length) {

            const media =
                getMedia();

            if (!media)
                return;


            const container =
                document.createElement('div');

            container.className =
                'product-page-badges';


            media.appendChild(
                container
            );


            containers = [
                container
            ];

        }


        containers.forEach(container => {

            /*
             * Evita duplicação
             */

            if (
                container.querySelector(
                    '.algodao-banner'
                )
            ) {
                return;
            }


            const badge =
                createAlgodaoBadge();


            if (badge) {

                container.appendChild(
                    badge
                );

            }

        });

    };


    /* ==========================================
       MOVE BADGES PARA A MÍDIA
    ========================================== */

    const moveBadges = () => {

        const media =
            getMedia();

        if (!media)
            return;


        media.style.position =
            'relative';


        const badges =
            document.querySelectorAll(
                '.product-page-badges'
            );


        badges.forEach(badge => {

            if (
                badge.parentElement !== media
            ) {

                media.appendChild(
                    badge
                );

            }


            badge.classList.add(
                'is-ready'
            );

        });


        /*
         * Depois de posicionar os badges,
         * verifica Sou de Algodão.
         */

        updateAlgodaoBadge();

    };


    /* ==========================================
       INICIALIZA
    ========================================== */

    const init = () => {

        moveBadges();


        document.addEventListener(
            'variant:change',
            () => {
                requestAnimationFrame(
                    moveBadges
                );
            }
        );


        document.addEventListener(
            'slideChanged',
            () => {
                requestAnimationFrame(
                    moveBadges
                );
            }
        );


        window.addEventListener(
            'resize',
            () => {
                requestAnimationFrame(
                    moveBadges
                );
            }
        );


        /*
         * Ajuda quando o tema carrega partes
         * da PDP de forma dinâmica.
         */

        const observer =
            new MutationObserver(() => {

                if (
                    getAlgodaoMarker()
                ) {

                    moveBadges();

                }

            });


        observer.observe(
            document.body,
            {
                childList: true,
                subtree: true
            }
        );


        requestAnimationFrame(
            moveBadges
        );

    };


    if (
        document.readyState ===
        'loading'
    ) {

        document.addEventListener(
            'DOMContentLoaded',
            init,
            { once: true }
        );

    } else {

        init();

    }

})();